import React from 'react';
import { Icon, Tooltip, Whisper } from 'rsuite';
import PropTypes from 'prop-types';
import { get, getOr } from 'lodash/fp';
import { InventorySnapshotType } from '../../interfaces/reservation';

const IconTooltip = ({ snapshot, ...props }) => {
  const zoneName = getOr('', 'zone.name', snapshot);
  const linkedItemName = get('item.name', snapshot);
  const locationName = get('location.name', snapshot);

  return (
    <Tooltip {...props}>
      {linkedItemName} -{' '}
      <em>
        {locationName} {zoneName && `, ${zoneName}`}
      </em>
    </Tooltip>
  );
};

IconTooltip.propTypes = {
  snapshot: InventorySnapshotType.isRequired
};

const LinkedInventoryIcon = ({ inventorySnapshot, style, ...props }) => (
  <Whisper
    placement="top"
    trigger="hover"
    speaker={<IconTooltip snapshot={inventorySnapshot} />}
  >
    <Icon
      {...props}
      icon="info"
      style={{
        ...style,
        color: '#87cce7',
        background: 'white',
        borderRadius: 10
      }}
    />
  </Whisper>
);

LinkedInventoryIcon.propTypes = {
  inventorySnapshot: InventorySnapshotType.isRequired,
  style: PropTypes.shape({})
};

LinkedInventoryIcon.defaultProps = {
  style: {}
};

export default LinkedInventoryIcon;
